import React, {useContext, useState,useEffect} from "react";
import {Link, useHistory} from "react-router-dom";
import {Button, Dropdown, HeaderButtonBack, HeaderContext, IconButton, Nav} from "@deere/ux.uxframe-react";
import {ReactComponent as HomeIcon} from '@deere/ux.brand-foundations/icons/home.svg';
import {useDispatch, useSelector} from "react-redux";
import {isHighRiskDealer} from "../dealer-search/DealerSlice";
import {machinesList, resetMachineState, setSearchedPin} from "../machine-search/machineSearchSlice";
import {resetCustomersData} from "../customer-search/customersSlice";
import {useOktaAuth} from "@okta/okta-react";
import wtyReportApi from "../../services/warrantyReportAxios";
import {fetchTranslations, languageResponseData} from "../Translation/translationSerachSlice";
import {useTranslation} from "../Translation/TranslationContext";

const UxfCustomNavbarReactRouter = () => {
    const { loadTranslations } = useTranslation();
    const dispatch = useDispatch();
    const context = useContext(HeaderContext);
    const history = useHistory();
    const isDealerRestricted = useSelector(isHighRiskDealer);
    const {authState} = useOktaAuth();
    const userType = authState.idToken.claims.userType;

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };
    /*const LanguageSelector = () => {
        const { loadTranslations } = useTranslation();
    }*/

    const [selectedLanguage, setSelectedLanguage] = useState('Language Search');
    const languageResponse = useSelector(languageResponseData);

    const localeActions = {
        English:'en_US',
        Français: 'fr_FR',
        Deutsch: 'de_DE',
        Italiano: 'it_IT',
        Português:'pt_PT',
        Español: 'es_ES',
        中文: 'zh_CN',
        Russian: 'ru_RU',
        Türkçe: 'tr_TR',
        Polski: 'pl_PL'
    };

    useEffect(() => {
        // Retrieve the selected language from local storage
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage) {
            const locale = localeActions[savedLanguage];
            loadTranslations(locale);
            dispatch(fetchTranslations({ locale }));
            setSelectedLanguage(savedLanguage);
        }
    }, [dispatch, loadTranslations]);

    const handleClick = (language, path) => (event) => {
        event.preventDefault();
        event.stopPropagation();

        context.onClickLink();
        const locale = localeActions[language];

        loadTranslations(locale);
        dispatch(fetchTranslations({locale}));
        setSelectedLanguage(language);

        localStorage.setItem('selectedLanguage', language);
        //window.location.reload();


        dispatch(setSearchedPin(""));
        dispatch(resetMachineState());
        dispatch(resetCustomersData());
        /*history.push("/machine-search");*/

        if (path) {
            history.push(path);
        } else {
            history.push("/machine-search");
        }

    };

    const openInNewTab = (link) => {
        context.onClickLink();
        window.open(link);
    }

    const authToken = async () => {
        const token = await wtyReportApi.get("/usat-token/get-usat-token");
        return token.data;
    }

    return (
        <>
            <Nav.Item className="uxf-nav-item-icon active">
                {/*<Nav.Link to="/" onClick={handleClick} className="nav-icon" aria-label="home page">
                    <HomeIcon className="nav-home-icon"/>
                </Nav.Link>*/}
                {/*<IconButton ariaLabel="Home" noHover={true} onClick={handleClick}><HomeIcon className="nav-home-icon"/></IconButton>*/}
                <IconButton ariaLabel="Home" noHover={true} onClick={handleClick(selectedLanguage, "/home")}>
                    <HomeIcon className="nav-home-icon"/>
                </IconButton>
            </Nav.Item>
            {/*<Nav.Item>
                <Nav.Link as={Link} to="/dashboard" onClick={handleClick}>
                    <span className="uxf-link-text">Dashboard</span>
                </Nav.Link>
            </Nav.Item>*/}
            <Dropdown as={Nav.Item} style={{ textAlign: 'center' }}>
                <Dropdown.Toggle as={Nav.Link} id="languageSearchDropdown">
                    <span className="uxf-link-text">{selectedLanguage}</span> {/* Display the selected language */}
                </Dropdown.Toggle>
                <Dropdown.Menu renderOnMount>
                    {Object.keys(localeActions).map(language => (
                        <Dropdown.Item key={language} onClick={handleClick(language)}>
                            {language}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>


            <Dropdown as={Nav.Item} style={{textAlign: 'center'}}>
                <Dropdown.Toggle as={Nav.Link} id="machineSearchDropdown">
                    <span className="uxf-link-text">{translate("machinesearch", 'Machine Search')}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu renderOnMount>
                    <HeaderButtonBack>Menu</HeaderButtonBack>
                    <Dropdown.Item as={Link} to="/" onClick={handleClick}>
                        {translate('search_by_serial', 'Search By Serial Number')}
                        </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/machine-search/dealer" onClick={handleClick}>
                        {translate('search_dealer', 'Search by Dealer')}
                        </Dropdown.Item>
                    {
                        !isDealerRestricted ? (
                            <Dropdown.Item as={Link} to="/machine-search/customer" onClick={handleClick}>
                                {translate('search_customer', 'Search by Customer')}</Dropdown.Item>
                        ) : (<></>)
                    }
                </Dropdown.Menu>
            </Dropdown>

            <Nav.Item>
                <Nav.Link as={Link} to="/claim-search/claimNumber" onClick={handleClick}>
                    <span className="uxf-link-text">{translate('claimsearch', 'Claim Search')}</span>
                </Nav.Link>
            </Nav.Item>

            <Nav.Item>
                <Nav.Link as={Link} to="/expiration-report" onClick={handleClick}>
                    <span className="uxf-link-text">{translate('expiration_report', 'Expiration Report')}</span>
                </Nav.Link>
            </Nav.Item>


            <Dropdown as={Nav.Item} style={{textAlign: 'center'}}>
                <Dropdown.Toggle as={Nav.Link} id="ExternalLinksDropdown">
                    <span className="uxf-link-text">{translate('external_link', 'External Links')}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu renderOnMount>
                    <Dropdown.Item onClick={() => openInNewTab("http://jdpsproductdata.deere.com")}>
                        {translate("engine_option", 'Engine Options')}
                    </Dropdown.Item>
                    {
                        userType !== "Dealer Employee" ?(
                        <Dropdown.Item onClick={() => openInNewTab("https://mpr.deere.com/mpr/")}>
                            {translate("mpr", 'Machine Population Report')}

                            </Dropdown.Item>
                        ) : (<></>)
                    }

                    {
                        userType.substring(1,6) === "Dealer" ? (
                            <Dropdown.Item onClick={() => openInNewTab("https://mpr.deere.com/mpr/")}>
                            Machine Population Report
                        </Dropdown.Item>
                        ) : (<></>)
                    }
                </Dropdown.Menu>
            </Dropdown>

                {/*{
                userType !== "Dealer Employee" ? (
                    <Nav.Item>
                    <Nav.Link onClick={() => openInNewTab("https://forms.microsoft.com/r/nZwq9yuX1C")}>
                        <span className="uxf-header-title-username">Feedback</span>
                    </Nav.Link>
                </Nav.Item>
                ) : (<></>)
            }*/}
            <Nav.Item>
                <Nav.Link onClick={async () => {
                    window.displayLoading();
                    const token = await authToken();
                    if (token !== undefined) {
                        window.hideLoading();
                        window.popUpFunction({
                              env: process.env.REACT_APP_ENV,
                            userId: authState.idToken.claims.userType === "Dealer Employee" ? 3 : 1,
                            token: `${token}`,
                            productId: 'MID92',
                            language: 'en-US'
                        });
                    }
                }}>
                    <span className="uxf-header-title-username">{translate("feedback", 'Feedback')}</span>
                </Nav.Link>
            </Nav.Item>

          {/*  <Nav.Item>
                <Nav.Link as={Link} to="/whats-new" onClick={handleClick} style={{backgroundColor: '#ffde00'}}>
                    <span className="uxf-header-title-username"><b>{translate("whats_new", 'Whats New')}</b></span>
                </Nav.Link>
            </Nav.Item>*/}


            {/*<Nav.Item>
                    <Button variant="link"
                            style={{
                                textDecoration: 'underline',
                                color: 'green',
                            }}
                            onClick={()=> openInNewTab("https://warrantyreports-legacy.deere.com")}
                    >Switch to old Warranty Reports</Button>
            </Nav.Item>*/}


        </>
    );
};

export default UxfCustomNavbarReactRouter;